import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonComponent } from '@interacta-shared/ui';
import { AppBaseRoute } from '@modules/app-routing/routes';
import { AppSelectors, AppState } from '@modules/core/store';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-skip-links',
    imports: [TranslatePipe, ButtonComponent],
    templateUrl: './skip-links.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkipLinksComponent {
    private readonly store = inject(Store<AppState>);

    goToMainContentExcluded: AppBaseRoute[] = [
        'login',
        'error',
        'bootcamp',
        'unsubscribe',
        'customer-feedback',
    ];
    goToSidebarExcluded: AppBaseRoute[] = [
        'post-edit',
        'post-detail',
        'error',
        'login',
        'profile',
        'post-edit-draft',
        'post-print',
        'post-feedback',
        'post-relation',
        'post-i-lab',
        'search',
        'bootcamp',
        'community-detail',
        'notification-settings',
        'bulk-workflow-transition',
        'unsubscribe',
        'customer-feedback',
    ];
    routeState = this.store.selectSignal(AppSelectors.selectRouteState);

    setFocus(goTo: 'main-content' | 'sidebar'): void {
        document.getElementById(goTo)?.focus();
    }
}
